import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { BlogHero, ArticleList } from '../../components/Blog';
import { getAllArticles } from '../../data/blog';
import { trackBlogIndexView } from '../../utils/analytics';

const BlogIndex: React.FC = () => {
  const articles = getAllArticles();

  useEffect(() => {
    document.title = 'Blog Dépannage Informatique | SOS IT Services';

    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute(
      'content',
      'Guides pratiques et solutions pour dépanner votre PC : virus, lenteurs, réseau, Windows, récupération de données. Conseils rédigés par nos techniciens.',
    );

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://sos-it-services.fr/blog');

    const ogTags: Record<string, string> = {
      'og:title': 'Blog Dépannage Informatique | SOS IT Services',
      'og:description':
        'Guides pratiques, astuces et solutions pour tous vos problèmes informatiques.',
      'og:url': 'https://sos-it-services.fr/blog',
    };
    Object.entries(ogTags).forEach(([property, content]) => {
      let tag = document.querySelector(`meta[property="${property}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    });

    window.scrollTo(0, 0);

    trackBlogIndexView('all');
  }, []);

  return (
    <div className="pt-16 md:pt-20 min-h-screen bg-[#2F3136]">
      <BlogHero />

      <div className="h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />

      <section className="py-14 bg-[#2F3136]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            className="mb-8"
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.45, ease: 'easeOut' }}
          >
            <h2 className="text-xl md:text-2xl font-bold text-white">
              Tous les articles{' '}
              {articles.length > 0 && (
                <span className="text-gray-400 font-normal text-base">({articles.length})</span>
              )}
            </h2>
          </motion.div>

          <ArticleList articles={articles} perPage={9} />
        </div>
      </section>
    </div>
  );
};

export default BlogIndex;
